import { PlayerType } from '../../builder-config';
import { TransformPlayerConfig } from './transform-player-config';

/**
 * This function is used to add the Bitmovin license key to the player config.
 *
 * @remarks
 * The Bitmovin Player requires a valid license key, which may be different for each environment and client,
 * and is thus stored in the remote config.
 *
 * Be aware that the key is stored in the root player config, and thus only applicable if the Bitmovin player is used.
 */
export const addBitmovinLicenseKey: TransformPlayerConfig = (partialBuilderConfig, playerConfig) => {
  if (partialBuilderConfig.playerType !== PlayerType.Bitmovin) {
    return playerConfig;
  }

  if (!partialBuilderConfig.remoteConfig.bitmovinPlayer?.licenseKey) {
    return playerConfig;
  }

  return {
    ...playerConfig,
    rootPlayerConfig: {
      ...playerConfig.rootPlayerConfig,
      key: partialBuilderConfig.remoteConfig.bitmovinPlayer.licenseKey,
    },
  };
};
